import { FORM_INPUT_CHANGE, FORM_INPUT_CHANGE_MULTIPLE, PATIENT_FORM_DETAILS, PATIENT_FORM_DETAILS_SUCCESS, PATIENT_FORM_DETAILS_FAILURE } from '../Utils/Constants';

export const formInputChange = (payload) => {
    return {
        type: FORM_INPUT_CHANGE,
        payload: payload
    }
}

export const formInputChangeMultiple = (payload) => {
    return {
        type: FORM_INPUT_CHANGE_MULTIPLE,
        payload: payload
    }
}

export const patientFormDetails = (payload) => {
    return {
        type: PATIENT_FORM_DETAILS,
        payload: payload
    }
}

export const patientFormDetailsFailure = (payload) => {
    return {
        type: PATIENT_FORM_DETAILS_FAILURE,
        payload: payload
    }
}

export const patientFormDetailsSuccess = (payload) => {
    return {
        type: PATIENT_FORM_DETAILS_SUCCESS,
        payload: payload
    }
}

